import api from './api';
import API_CONFIG from '../config/api.config';

const notaFiscalService = {
  // Enviar nota fiscal
  async enviarNotaFiscal(compraId, arquivo, numeroNota) {
    try {
      const formData = new FormData();
      formData.append('nota_fiscal', arquivo);
      formData.append('numero_nota', numeroNota);

      const response = await api.post(
        API_CONFIG.ENDPOINTS.COMPRAS.ENVIAR_NOTA_FISCAL(compraId),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Baixar nota fiscal
  async baixarNotaFiscal(compraId) {
    try {
      const response = await api.get(
        API_CONFIG.ENDPOINTS.COMPRAS.DOWNLOAD_NOTA_FISCAL(compraId),
        {
          responseType: 'blob',
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Função auxiliar para fazer download do arquivo
  fazerDownload(blob, nomeArquivo) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },

  // Novo método: abrir PDF em nova guia
  async abrirNotaFiscalEmNovaGuia(compraId) {
    try {
      const response = await api.get(
        API_CONFIG.ENDPOINTS.COMPRAS.DOWNLOAD_NOTA_FISCAL(compraId),
        {
          responseType: 'blob',
        }
      );
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      // Opcional: revogar depois de um tempo
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);
    } catch (error) {
      throw error;
    }
  }
};

export default notaFiscalService; 